import { Box, Button, Flex, Heading, Input, InputGroup, SimpleGrid, Text } from '@chakra-ui/react';
import { UseFormReturn } from 'react-hook-form';
import { useDebouncedFieldRegistry } from '@/utils/filterUtils/useDebouncedFieldRegistry';
import { ChakraFeatherIcon } from 'src/components/ChakraFeatherIcon';
import { TeamTimelineFilters } from '../../types';
import { useTranslation } from 'react-i18next';
import { Club } from '@/model';
import TeamFilterSelect from '@/components/TeamFilterSelect';

export interface TeamTimelineFilterBoxProps {
  clubs: Club[];
  filtersForm: UseFormReturn<TeamTimelineFilters>;
  forceRefetch: () => void;
}

export const TeamTimelineFilterBox = ({ clubs, filtersForm }: TeamTimelineFilterBoxProps) => {
  const { register, reset } = filtersForm;
  const { t } = useTranslation();

  return (
    <Box>
      <Flex align='center' gap='pico' mb='deka'>
        <ChakraFeatherIcon color='text.main' name='filter' />
        <Heading variant='sectionTitle'>
          {t('pages.application_history_timeline.components.team_timeline_filter_box.team_timeline_filter_box_title')}
        </Heading>
      </Flex>

      <Flex direction={{ base: 'row' }} gap='small' rowGap='micro'>
        <SimpleGrid
          gap='deka'
          alignItems='flex-end'
          columns={{ base: 1, sm: 2, md: 4, lg: 5, xl: 6 }}
          rowGap='xxsmall'
          flexGrow={1}
        >
          <TeamFilterSelect showFlag name='team_uuid' control={filtersForm.control} clubs={clubs} width='100%' />

          <InputGroup display='flex' flexDirection='column'>
            <Text fontWeight='medium'>
              {t('pages.application_history_timeline.components.team_timeline_filter_box.team_timeline_filter_box_title_label')}
            </Text>
            <Input variant='flushed' {...useDebouncedFieldRegistry(() => register('title'))} />
          </InputGroup>

          <InputGroup display='flex' flexDirection='column'>
            <Text fontWeight='medium'>
              {' '}
              {t('pages.application_history_timeline.components.team_timeline_filter_box.team_timeline_filter_box_year_label')}
            </Text>
            <Input variant='flushed' {...useDebouncedFieldRegistry(() => register('year'))} />
          </InputGroup>
        </SimpleGrid>

        <Button alignSelf={{ lg: 'end' }} colorScheme='text' variant='outline' mt='10px' onClick={() => reset()}>
          {t('pages.application_history_timeline.components.team_timeline_filter_box.team_timeline_filter_box_clear_button')}
        </Button>
      </Flex>
    </Box>
  );
};
